import { SearchInput } from "@volca/ui/components/ui/search-input";
import { Stack } from "@volca/ui/components/ui/stack";
import type { ApDayRange } from "@/accounts-payable/query";
import type { ApDocumentType } from "@/accounts-payable/types";
import { ChoiceFilterChip } from "./choice-filter-chip";
import { DayFilter, type DayField } from "./day-filter";

export interface DocumentStatusFilter {
  key: string;
  label: string;
}

/**
 * The filter row above an AP document list (Invoices, Receipts): status,
 */
export const DocumentListFilters = ({
  kind,
  statusFilters,
  status,
  onStatusChange,
  dayField,
  onDayFieldChange,
  dayRange,
  onDayRangeChange,
  search,
  onSearchChange,
  searchPlaceholder,
}: {
  kind: ApDocumentType;
  statusFilters: DocumentStatusFilter[];
  status: string;
  onStatusChange: (key: string) => void;
  dayField: DayField;
  onDayFieldChange: (field: DayField) => void;
  dayRange: ApDayRange | null;
  onDayRangeChange: (range: ApDayRange | null) => void;
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
}) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    gap={2}
    wrap
    className="w-full flex-none py-4"
  >
    {/* The chips wrap on a phone; search takes a line of its own. */}
    <Stack
      direction="row"
      gap={2}
      align="center"
      wrap
      className="w-full sm:w-auto"
    >
      <ChoiceFilterChip
        label="Status"
        options={statusFilters}
        value={status}
        clearKey={statusFilters[0]?.key}
        onChange={onStatusChange}
      />
      <DayFilter
        kind={kind}
        field={dayField}
        onFieldChange={onDayFieldChange}
        value={dayRange}
        onChange={onDayRangeChange}
      />
    </Stack>
    {/* SearchInput's own wrapper shrink-wraps the input; this one stretches
        it so the field spans a phone's width. 300px from sm up, as before. */}
    <Stack gap={0} align="stretch" className="w-full max-w-full sm:w-auto">
      <SearchInput
        placeholder={searchPlaceholder}
        value={search}
        onChange={onSearchChange}
        className="max-w-full max-sm:mx-0 max-sm:w-full"
      />
    </Stack>
  </Stack>
);
